export function modalAlert(message, title = 'Alert...') {
	return new Promise(done => {
		$("#alertModal").find('.modal-body').html(`<p>${message}</p>`);
		$("#alertModalLabel").html(title);
		$("#alertModal").modal('show');
		$('#alertModal').one('hidden.bs.modal', function (event) {
			done();
		});
	});
}